export default "__VITE_ASSET__Bm3rU1Pw__"